import React from 'react';
import DropTrackListItem from './DropTrackListItem';
import { useSelector } from 'react-redux';

function DropTrackProductsList() {
    const dropTrackList = useSelector((state) => state.dropTrackProducts.dropTrackList.dropTrackList);
    const error = useSelector((state) => state.dropTrackProducts.dropTrackList.error);

    return (
        <div className="mt-6 mx-5">
            <div className="mt-3 border border-[#EAEAEA] rounded-lg overflow-hidden">
                <div className="flex bg-[#F5F5F5] text-[#666666] font-semibold select-none">
                    <h2 className="w-[44%] max-[1280px]:w-[39.5%] px-[10px] py-2 text-[14px] leading-6 uppercase">Product</h2>
                    <h2 className="w-[14%] max-[1280px]:w-[16%] max-[1152px]:w-[15%] max-[1080px]:w-[13%] px-[10px] py-2 text-[14px] leading-6">DropTrack Watchers</h2>
                    <h2 className="w-[13%] max-[1280px]:w-[13%] px-[10px] py-2 text-[14px] leading-6">Current price</h2>
                    <h2 className="w-[13%] max-[1280px]:w-[13%] max-[1152px]:w-[12%] px-[10px] py-2 text-[14px] leading-6">Available Stock</h2>
                    <h2 className="w-[16%] max-[1280px]:w-[18.5%] max-[1152px]:w-[20.5%] max-[1080px]:w-[22.5%] px-[10px] py-2 text-[14px] leading-6">Action</h2>
                </div>

                {!error && dropTrackList?.filter(product => product.productId).map(product => {
                    return (
                        <DropTrackListItem 
                            key={product.id} 
                            product={product}
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default DropTrackProductsList;
